import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";
import cn from "classnames";
import "./Spinner.scss";

const Spinner = ({
  size = 32,
  line = 4,
  lineColor = COLOR_PRIMARY,
  borderColor = "#eee",
  className,
}: {
  size?: number;
  line?: number;
  lineColor?: string;
  borderColor?: string;
  className?: string;
}) => {
  return (
    <div
      className={cn("spinner", className)}
      style={{
        width: size,
        height: size,
        maxHeight: size,
        maxWidth: size,
        border: `${line}px solid ${borderColor}`,
        borderTop: `${line}px solid ${lineColor}`,
        borderRadius: "50%",
      }}
    ></div>
  );
};

export default Spinner;
